import { render } from "./ParallelVis .vue?vue&type=template&id=531dca9d&scoped=true"
import script from "./ParallelVis .vue?vue&type=script&lang=js"
export * from "./ParallelVis .vue?vue&type=script&lang=js"

import "./ParallelVis .vue?vue&type=style&index=0&id=531dca9d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531dca9d"]])

export default __exports__